var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpDeviceCheckIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.33301H14C14.1768 5.33301 14.3464 5.40325 14.4714 5.52827C14.5964 5.65329 14.6667 5.82286 14.6667 5.99967V13.9997C14.6667 14.1765 14.5964 14.3461 14.4714 14.4711C14.3464 14.5961 14.1768 14.6663 14 14.6663H8.66667C8.48986 14.6663 8.32029 14.5961 8.19526 14.4711C8.07024 14.3461 8 14.1765 8 13.9997V13.333H2.66667C2.48986 13.333 2.32029 13.2628 2.19526 13.1377C2.07024 13.0127 2 12.8432 2 12.6663V1.99967C2 1.82286 2.07024 1.65329 2.19526 1.52827C2.32029 1.40325 2.48986 1.33301 2.66667 1.33301H12C12.1768 1.33301 12.3464 1.40325 12.4714 1.52827C12.5964 1.65329 12.6667 1.82286 12.6667 1.99967V5.33301ZM11.3333 5.33301V2.66634H3.33333V11.9997H8V5.99967C8 5.82286 8.07024 5.65329 8.19526 5.52827C8.32029 5.40325 8.48986 5.33301 8.66667 5.33301H11.3333ZM9.33333 6.66634V13.333H13.3333V6.66634H9.33333Z",
    fill: "#85858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpDeviceCheckIc);
export default __webpack_public_path__ + "static/media/ip-device-check-ic.fc4ee6f37faaf26cba2b4c0488b7bc7f.svg";
export { ForwardRef as ReactComponent };